<style scoped lang="less">

  .unread {
    font-weight: bold;
    font-size: 1.2em;
  }
  .read {
    color: #777;
  }
  .read td {
    font-size: 0.8em;
  }
  .h-select-no-autosize {
    display: inline-block;
  }
</style>

<style>
  .f360-wordwrap div {
    word-break: normal;
    word-wrap: normal;
  }

  .upload-badge.h-badge .h-badge-count {
    position: absolute;
    left: -7px;
    top: -8px;
  }
  @media (max-width: 390px){
    .row-btns .h-btn {
      display: inline-block;
      width: 100%;
      margin: 5px 0;
    }
  }
  /* filtro */
  .vendas-filtro .h-datetime-range .h-datetime-show {
    min-width: auto !important;
  }
  .inputs-filtro {
    width: 100%;
  }
  .filter-label-inputs {
    background: #e0e0e0;
    border-radius: 3px;
    float:right; padding: 0 5px;
  }
  .filter-label-inputs .span-dp {
    position:relative;
    top:2px;
  }
  div.filter-min-control{
    display: inline-block;
  }
  .filter-min-control div.h-numberinput-show{
    background: initial;
    width: 30px;
    display: inline-block;
    border: none;
  }
  .filter-min-control input.h-input{
    display: inline-block;
    height: 17px;
    width: 30px;
    min-width: 0;
    padding: 0px;
    padding-left: 0px;
    background-color: #e0e0e0;
    border-width: inherit;
    cursor: text;
    border: 0;
    font-weight: 600;
  }
  .vendas-filtro .h-panel {
    border: 1px solid #eee;
  }
  .h-panel-body.vendas-filtro .h-collapse-item-expand {
    position: absolute;
    display: none;
  }
  .h-panel-body.vendas-filtro .h-panel-bar {
    padding: 0px 12px;
  }
  .masc-disabled {
    position: absolute;
    height: 100%;
    width: 96%;
    bottom: 0;
    border-radius: 3px;
    left: 5px;
    z-index: 1;
    background: rgba(204, 204, 204, 0.23);
    cursor:no-drop;
  }
  .filter-required-lbl {
    color: #ff6565;
    float: right;
  }
  .datavendarange-ipt input.h-input {
    width:100px;
    display:inline-block;
  }
  .vendas-window .h-table th {
    padding: 5px 0 5px 16px;
    height: 35px;
  }
  .vendas-window .h-table td {
    height: 40px;
  }
  .h-panel-filtro .h-collapse-item-content-box {
    padding: 0px !important;
  }
  .aviso-maxpage {
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
    padding: 27px;
    border-radius: 4px;
  }
</style>

<template>
    <div class="app-form frame-page basic-form-vue">
      <div class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">Arquivos</span>
        </div>

        <div class="h-panel-body vendas-filtro">
          <div class="h-panel h-panel-filtro">
            <Collapse v-model="filterCollapse" accordion>
              <CollapseItem>
                <template slot='title'>
                  <div class="h-panel-bar">
                    <span class="h-panel-title">Filtro</span>
                    <span class="h-panel-right">
                      <Button style="margin-right: -6px;" :icon-circle='true' :circle="true" :icon="'h-icon-'+(filterCollapse.length ? 'minus' : 'plus')"></Button>
                    </span>
                  </div>
                </template>
                <div class="h-panel-body">
                  <Row :space="10">
                    <!-- Filtro detalhado -->
                    <div class="h-row h-row-vendas">
                      <Cell :xs='24' :sm='8' :md='8' :lg='8' :xl='8'>
                        <label>Data de criação:</label>
                        <DatePicker v-width="'100%'" placeholder="Data do processamento" v-model="search.criadoEm" type="date" format="DD/MM/YYYY"></DatePicker>
                      </Cell>
                      <Cell :xs='24' :sm='8' :md='8' :lg='8' :xl='8'>
                        <label>Status:</label>
                        <Select v-width="'100%'" placeholder="Status" v-model="search.status" :datas="select.status"></Select>
                      </Cell>
                      <Cell :xs='24' :sm='8' :md='8' :lg='8' :xl='8'>
                        <label>Tipo:</label>
                        <Select v-width="'100%'" placeholder="Tipo" v-model="search.tipo" :datas="select.tipo"></Select>
                      </Cell>
                      <Cell :xs='24' :sm='8' :md='4' :lg='4' :xl='2'>
                          <Button color="white" :block="true" icon="h-icon-refresh" @click.native="clearFiltro">Limpar</Button>
                        </Cell>
                      <Cell :xs='24' :sm='8' :md='4' :lg='4' :xl='2'>
                        <Permissao :permissao="!temPermissaoParaListarArquivos">
                          <Button color="green" :block="true" icon="h-icon-search" :loading='isLoadingFilter' :disabled="!temPermissaoParaListarArquivos" @click.native="filtrar">Filtrar</Button>
                        </Permissao>
                      </Cell>
                      <Cell :xs='24' :sm='6' :md='6' :lg='4' :xl='2' style="float: right !important;">
                        <Permissao :permissao="!temPermissaoExportarArquivo">
                          <Button color="blue" :block="true" icon="h-icon-inbox" :loading='isLoadingExport' @click.native="filtrar(true)" :disabled="!temPermissaoExportarArquivo">Exportar</Button>
                        </Permissao>
                      </Cell>
                      <Cell :xs='24' :sm='8' :md='6' :lg='6' :xl='6' style="float:right;">
                        <Permissao :permissao="!temPermissaoDownloadArquivo">
                          <Button color="blue" title="Download dos arquivos selecionados" :disabled="disable.downloadArquivos || !temPermissaoDownloadArquivo" :block="true" icon="h-icon-inbox" :loading='isLoadingArquivo' @click.native="downloadArquivoOriginal">Download Arquivo</Button>
                        </Permissao>
                      </Cell>
                    </div>
                  </Row>
                </div>
              </CollapseItem>
            </Collapse>
          </div>
        </div>
        <div class="h-panel-body" style="padding-top: 0;">
          <!-- <div class="row-btns h-row">
            <button style="font-size: 0.9em;" :disabled="disable.downloadArquivos" class="h-btn h-btn-primary" title="arquivar mensagem" @click="downloadArquivoOriginal">
              <i class="fas fa-download"></i>
              <span>Download Arquivo</span>
            </button>

            <button style="font-size: 0.9em;" :disabled="disable.downloadVendas" class="h-btn h-btn-green" title="Realizar download do arquivo de vendas. Botão só será liberado se existirem seleções com número de linha lidos maior que zero." @click="downloadVendas">
              <i class="fas fa-download"></i>
              <span>Download Arquivo de Vendas</span>
            </button>
          </div> -->

          <template v-if="avisoMaxPaginacao">
            <div class="aviso-maxpage">
              <strong>
                Você já utilizou nossos filtros?
              </strong><br>
              <p>Utilize-os e refine a busca para obter melhores resultados.</p>
              <p>
                Mas se você precisar, também poderá clicar no botão a seguir para exportar o resultado completo dessa pesquisa para Excel. Em alguns minutos você receberá o retorno no e-mail cadastrado.
              </p>
              <Row>
                <Cell :xs='24' :sm='12' :md='6' :lg='6' :xl='3'>
                  <Button color="blue" :block="true" icon="h-icon-inbox" :loading='isLoadingExport' @click.native="filtrar(true)" :disabled="temPermissaoExportarArquivo">Exportar para Excel</Button>
                </Cell>
              </Row>
            </div>
          </template>
          <template v-else>
            <Table border :height="400" checkbox @select="tableOnSelect" stripe ref="table" selectWhenClickTr :datas="arquivos" @sort="triggerSort" :loading="loadingTable">
              <TableItem title="Nome" :width="170" prop="nomeArq" :sort="true">
                <template slot-scope="{data}">
                  <Badge class="upload-badge" :count="data.totalNotas" :max-count="99" :title="data.totalNotas > 0 ? 'Existem notas nesse processamento' : ''">
                    <div class="text-center">
                      <img :src="loadImage(data)" width="16" />
                      <span style="position: relative; top: -4px; left: 3px;">
                        {{data.nome}}
                      </span>
                    </div>
                  </Badge>
                </template>
              </TableItem>
              <TableItem title="Status" prop="status" :width="85" :sort="true"></TableItem>
              <TableItem title="Tipo" prop="tipoDocumentoImportado" :width="150" :sort="true"></TableItem>
              <TableItem title="Atualização" :render="formatarData" prop="atualizadoEm" :width="140" :sort="true"></TableItem>
              <TableItem title="Itens" prop="totalRegistrosUnicos" :width="70" :sort="true"></TableItem>
              <TableItem title="Inseridos Atualizados" className="f360-wordwrap" :width="98" :sort="true">

                <template slot-scope="{data}">

                  <Tooltip :content="data.totalLidos + ' / ' + data.totalAtualizados">
                    {{data.totalLidos+data.totalAtualizados}}
                  </Tooltip>

                </template>

              </TableItem>
              <TableItem title="Ignorados" prop="totalIgnorados" :width="75"></TableItem>

              <TableItem :width="60" title="Ações">
                <template slot-scope="{data}">

                  <DropdownCustom placement="bottom" trigger="hover" class-name="h-text-dropdown">
                    <i class="fas fa-cogs"></i>
                    <div slot="content">
                      <ul class="h-text-dropdown-dropdown h-dropdownmenu-group">
                        <li class="h-dropdownmenu-item" @click="$router.push(`/arquivos/${data._id}`)">
                            <span>
                              <i class="far fa-clipboard"></i>
                              &nbsp;Mostrar detalhe
                            </span>
                        </li>
                        <li class="h-dropdownmenu-item" @click="$router.push(`/vendas?arquivo=${data._id}`)">
                            <span>
                              <i class="h-icon-calendar"></i>
                              &nbsp;Visualizar Vendas
                            </span>
                        </li>
                      </ul>
                    </div>
                  </DropdownCustom>
                </template>
              </TableItem>
              <div slot="empty">Não existem arquivos</div>
            </Table>
          </template>
        </div>

        <div class="h-row affix-vendas">
          <Pagination align="center" v-model="pagination" @change="mudarPagina" :small="true" layout="total,pager,jumper"></Pagination>
        </div>

        <div class="h-row">&nbsp;</div>
      </div>
    </div>
</template>
<script>
import Manba from 'manba';
import { arquivos } from '../../../js/config/permissions';
import Permissao from '../../shared/NotificaoPermissao';
const TOTAL_ARQUIVOS_DOWNLOAD = 10;

export default {
  data() {
    return {
      disable: {
        downloadVendas: true,
        downloadArquivos: true
      },
      select: {
        status: [],
        tipo: []
      },
      search: {
        criadoEm: '',
        status: '',
        tipo: ''
      },
      arquivos: [],
      filterCollapse: [0],
      isLoadingFilter: false,
      isLoadingArquivo: false,
      pagination: { page: 1, size: 0, total: 0 },
      sendFilter: false,
      isLoadingExport: false,
      avisoMaxPaginacao: false,
      loadingTable: false
    };
  },
  components: {
    Permissao
  },
  mounted: async function () {
    this.search.criadoEm = Manba().format('DD/MM/YYYY');
    const respSelect = await R.Arquivo.getSelect();
    this.select.tipo = respSelect.data ? respSelect.data.tipo : [];
    this.select.status = Enumerable.from(respSelect.data.status).where(t => t.key !== '0').toArray();
  },
  watch: {
    search: {
      handler(val) {
        this.resetTable();
      },
      deep: true
    }
  },
  computed: {
    getSearch: function () {
      const filtro = {};
      const vm = this;

      if (vm.search.status) {
        filtro.status = vm.search.status;
      }
      if (vm.search.tipo) {
        filtro.tipo = vm.search.tipo;
      }
      if (vm.search.criadoEm) {
        filtro.criadoEm = Manba(vm.search.criadoEm, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      return filtro;
    },
    temPermissaoDownloadArquivo() {
      return Utils.getPermission(arquivos.downloadArquivo);
    },
    temPermissaoExportarArquivo() {
      return Utils.getPermission(arquivos.exportarArquivos);
    },
    temPermissaoParaListarArquivos() {
      return Utils.getPermission(arquivos.listarArquivos);
    }
  },
  methods: {
    resetTable() {
      // Reset table | pagination
      this.arquivos = [];
      this.pagination = { page: 1, size: 0, total: 0 };
    },
    listarArquivos: async function (isExport) {
      const mv = this;
      let load = isExport == true ? 'isLoadingExport' : 'isLoadingFilter';

      mv.loadingTable = true;
      mv[load] = true;

      if (isExport == true) {
        R.Arquivo.exportar(mv.getSearch).then(function (res) {
          mv.loadingTable = false;
          mv[load] = false;

          if (!res.data.length) {
            return;
          }
          mv.$Message.success(`Sucesso! Em breve você receberá um e-mail com a pesquisa feita.`);
        });
        return;
      }

      const respTotal = await R.Arquivo.total(this.getSearch);

      if (respTotal.data && respTotal.data.total > 0) {
        const respLista = await R.Arquivo.lista(this.pagination.page, this.getSearch);
        mv.arquivos = respLista.data;
      } else {
        mv.arquivos = [];
      }

      mv[load] = false;
      mv.loadingTable = false;

      mv.pagination.size = respTotal.data.pageSize;
      mv.pagination.total = respTotal.data.total;
    },
    filtrar: function (isExport) {
      this.sendFilter = true;
      setTimeout(() => {
        this.sendFilter = false;
      }, 7000);
      this.pagination.page = 1;

      this.listarArquivos(isExport);
      this.avisoMaxPaginacao = false;
    },
    mudarPagina: async function (value) {
      if (value.page >= 100) {
        this.avisoMaxPaginacao = true;
        return;
      }
      this.avisoMaxPaginacao = false;

      this.$Loading();
      const respLista = await R.Arquivo.lista(value.page, this.getSearch);
      this.$Loading.close();
      this.arquivos = respLista.data;
    },
    triggerSort: async function (data) { // evento de order/sort da table
      if (!this.arquivos.length) {
        return false;
      }

      this.loadingTable = true;

      const respLista = await R.Arquivo.lista(this.pagination.page, Object.assign(this.getSearch, {
        CampoOrdenacao: data.prop,
        FormaOrdenacao: data.type
      }));
      this.arquivos = respLista.data;
      this.loadingTable = false;
    },
    tableOnSelect(datas) {
      this.disable.downloadArquivos = !(datas.length > 0);
      this.disable.downloadVendas = !(datas.filter(x => x.status === 'Finalizado').length > 0);
    },
    downloadArquivoOriginal: async function () {
      const ids = Utils.getIdsTable(this.$refs.table);

      this.$Loading();
      this.isLoadingArquivo = true;
      await R.Arquivo.downloadSelecionados(ids);
      this.$Loading.close();
      this.isLoadingArquivo = false;

      this.$Message.success(`Sucesso! Em breve você receberá um e-mail com a pesquisa feita.`);
    },
    downloadVendas: async function () {
      const ids = this.$refs.table.getSelection().filter(x => x.status === 'Finalizado').map(x => x._id);
      this.$Loading();
      this.isLoadingArquivo = true;
      await R.Arquivo.exportar(ids);
      this.$Loading.close();
      this.isLoadingArquivo = false;
    },
    renderNome(data) {
      /* let html = `
        <img :src="${this.loadImage(data)}" width="16" />
        <span style="position: relative; top: -4px; left: 3px;">
          ${data.nome}
        </span>
      `; */
      return data.nome;
    },
    formatarData(arquivo) {
      return Utils.formatDateTime(arquivo.atualizadoEm);
    },
    loadImage(data) {
      // feito dessa por agilidade
      // ver como fazer carregamento dinamico de imagem no vuejs
      if (data.extensao === '.xlsx') { return require('@/images/icon/.xlsx.svg'); }
      if (data.extensao === '.xml') { return require('@/images/icon/.xml.svg'); }
      if (data.extensao === '.txt') { return require('@/images/icon/.txt.svg'); }
      if (data.extensao === '.xls') { return require('@/images/icon/.xls.svg'); }
      if (data.extensao === '.zip') { return require('@/images/icon/.zip.svg'); }
      return require('@/images/icon/outros.svg');
    },
    clearFiltro() {
      this.search.status = '';
      this.search.tipo = '';
    }
  }
};
</script>
